export default __webpack_public_path__ + "assets/front/scss/user-authentication.1ebb764ebf86b994feaa425b88f8019b.css";